// =============================================================
// 学習者番号の名簿（番号選択式ログインの選択肢）
//
// この方式は「認証」ではなく「識別」。番号は秘密情報ではなく、
// 誰の操作ログかを対応づけるためだけのラベル（割り切った設計）。
// パスワード入力を無くすことで授業時間内のログイン所要時間を最小化する。
//
// 名簿はサーバーに問い合わせず定数として持つ。40名が同時にログインしても
// 一覧表示にネットワークが介在しない＝表示は常に即時（要件: 2秒以内）。
//
// クラスに合わせて .env で変更できる:
//   REACT_APP_LEARNER_COUNT=40   … 番号の個数
//   REACT_APP_LEARNER_START=1    … 開始番号（例: 101 なら 101〜140）
// =============================================================

function readPositiveInt(value, fallback) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

export const LEARNER_COUNT = readPositiveInt(process.env.REACT_APP_LEARNER_COUNT, 40);
export const LEARNER_START = readPositiveInt(process.env.REACT_APP_LEARNER_START, 1);

export const LEARNER_NUMBERS = Array.from(
  { length: LEARNER_COUNT },
  (_, i) => LEARNER_START + i
);

// 管理者番号。学習者番号と同じ一覧の一番下に置き、この番号でログインしたときだけ
// Home に管理者画面の入口を出す（学習者には見せない）。
// 認証ではなく識別なので「学習者が押さないための仕切り」以上の意味は持たせない。
export const ADMIN_NUMBER = 999;

// 管理者番号でログインするときだけ求めるパスワード（2026-10-19）。
// ビルドに埋め込まれるので秘密にはならない。学習者が誤って 999 を選んでも入れないようにするための仕切り。
export const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'EBS';

// ログイン画面の選択肢（学習者番号＋末尾に管理者）
export const LOGIN_NUMBERS = [...LEARNER_NUMBERS, ADMIN_NUMBER];

export function isAdmin(userId) {
  return userId === ADMIN_NUMBER;
}

export function isValidLoginNumber(userId) {
  return LOGIN_NUMBERS.includes(userId);
}
